module.exports = __webpack_public_path__ + "img/HZ-G1221.28464a63.jpg";